import React, { useState } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { slides } from '../data/content';
const ARROW_CLASS = 'absolute top-1/2 flex h-11 w-11 -translate-y-1/2 items-center justify-center rounded-full bg-orange-500 text-slate-950 shadow-xl shadow-orange-500/40 ring-4 ring-orange-500/15 transition-[transform,background-color] duration-150 ease-out hover:bg-orange-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-orange-500 sm:h-14 sm:w-14';
export function LookInside() {
  const [index, setIndex] = useState(0);
  const slide = slides[index];
  const hasMultiple = slides.length > 1;
  const go = (direction: number) => {
    setIndex(current => (current + direction + slides.length) % slides.length);
  };
  return <section className="w-full bg-slate-950 px-5 py-12 text-white sm:py-16" data-id="element-92" data-mp="18y3heoez6p4c">
      <div className="mx-auto max-w-[1000px] text-center" data-id="element-93" data-mp="1dx6mu9yvaxcu">
        <p className="text-[0.85rem] font-bold uppercase tracking-[0.2em] text-white/80" data-id="element-94" data-mp="1dwn2kmlqvwvn">
          Look inside
        </p>
        <h2 className="mt-2 text-balance text-[1.6rem] font-extrabold uppercase leading-[0.95] tracking-tight sm:text-[2rem]" data-id="element-95" data-mp="612x1ku5wfe2">
          Discover What’s Inside{' '}
          <span className="text-orange-500" data-id="element-96" data-mp="k0c2pqkqrr3s">ANATOMY READY™</span>
        </h2>
        <p className="mx-auto mt-4 max-w-[600px] text-balance text-[1rem] leading-relaxed text-white/90" data-id="element-97" data-mp="f2so2pk4tcbb">
          Every body system, from cells to the whole body, with{' '}
          <strong className="font-bold text-white" data-id="element-98" data-mp="3iizp0ob5wvge">
            visual diagrams, worksheets, activities, assessments and answer
            keys.
          </strong>
        </p>

        <div className="relative mx-auto mt-8 max-w-[620px]" data-id="element-99" data-mp="3sgnlbiof2b0o">
          <figure data-id="element-100" data-mp="3sf2ti0thl66i">
            <img key={slide.image} src={slide.image} alt={slide.title} className="mx-auto w-full rounded-lg bg-white" width={804} height={1000} data-id="element-101" data-mp="3sekn4bd41bkv" />
            <figcaption className="mt-4 text-[1rem] font-extrabold uppercase leading-tight tracking-tight text-orange-500 sm:text-[1.15rem]" data-id="element-102" data-mp="13pn1vbmomr07">
              {slide.caption}
            </figcaption>
          </figure>

          {hasMultiple && <>
              <button type="button" onClick={() => go(-1)} aria-label="Previous page" className={`${ARROW_CLASS} -left-2 hover:-translate-x-0.5 sm:-left-7`} data-id="element-103" data-mp="1dh0x377lp4nj">
                <ChevronLeftIcon className="h-6 w-6" strokeWidth={3} aria-hidden="true" data-id="element-104" data-mp="poamp2fcitfd" />
              </button>
              <button type="button" onClick={() => go(1)} aria-label="Next page" className={`${ARROW_CLASS} -right-2 hover:translate-x-0.5 sm:-right-7`} data-id="element-105" data-mp="tpmcb7y7zenk">
                <ChevronRightIcon className="h-6 w-6" strokeWidth={3} aria-hidden="true" data-id="element-106" data-mp="257x965lu759r" />
              </button>
            </>}
        </div>

        <div className={`mt-4 items-center justify-center gap-2 ${hasMultiple ? 'flex' : 'hidden'}`} data-id="element-107" data-mp="2k943xizdxbxe">
          {slides.map((item, itemIndex) => <button key={item.image} type="button" onClick={() => setIndex(itemIndex)} aria-label={`Show ${item.title}`} aria-current={itemIndex === index} className={`h-2 rounded-full transition-[width,background-color] duration-150 ease-out focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-orange-500 ${itemIndex === index ? 'w-6 bg-orange-500' : 'w-2 bg-white/30'}`} data-id="element-108" data-mp="2fbufo6nqf6b5" data-mpi={itemIndex} />)}
        </div>

      </div>
    </section>;
}